import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { BoothsState } from '@/store/booths/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Booths: Module<BoothsState, RootState> = {
  state: (): BoothsState => ({
    booths: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
    allCountForCsvDownload: 0,
  }),
  mutations,
  actions,
  getters,
};

export default Booths;
